/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-21 11:44:29
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-09 17:09:56
 * @FilePath: /designcenter/src/api/modules/templateManange.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'
import type { AxiosRequestConfig } from 'axios'

const request = getApiRequest()

// 编辑或新增模板
export async function updateTemplate(data: any) {
  return request.post<IRes<unknown>>('/design/template/edit', data)
}

//配置模板拓扑图
export async function updateTemplateTopology(data: any) {
  return request.post<IRes<unknown>>('/design/topology/buildTemplateDiag', data)
}

//创建或修改业务特性
export async function createOrUpdateBusinessFeature(data: any) {
  return request.post<IRes<unknown>>('/design/template/editFeature', data)
}

//查询模板业务特性树
export async function getTemplateBusinessFeatureTree(params: any, config?: AxiosRequestConfig) {
  // 注意：展开 config 在前、params 在后，避免 config.params 覆盖函数入参 params
  return request.get<IRes<unknown>>('/design/template/featureTree', { ...config, params })
}

export async function getTemplateFeatureTree(params: any, config?: AxiosRequestConfig) {
  return getTemplateBusinessFeatureTree(params, config)
}

//查询模板列表
export async function getTemplateList(data: any) {
  return request.post<IRes<unknown>>('/design/template/page', data)
}

//删除模板
export async function deleteTemplate(data: any) {
  return request.post<IRes<unknown>>('/design/template/remove', data)
}

// 发布下架模板
export async function publishOrUnpublishTemplate(data: any) {
  return request.post<IRes<unknown>>('/design/template/operate', data)
}

//设置替换产品
export async function setTemplateReplaceProduct(data: any) {
  return request.post<IRes<unknown>>('/design/template/setReplaceProduct', data)
}

//获取替换产品列表
export async function getReplaceProductList(params: any) {
  return request.get<IRes<unknown>>('/design/product/replace', { params })
}

//删除替换产品
export async function deleteReplaceProduct(data: any) {
  return request.post<IRes<unknown>>('/design/template/removeReplaceProduct', data)
}

//设置模板拓扑图封面
export async function setTemplateCover(data: FormData) {
  return request.post<IRes<unknown>>('/design/template/setCover', data)
}

//校验封面图
export async function checkTemplateCover(params: any) {
  return request.get<IRes<unknown>>('/design/template/checkCover', { params })
}

//查询未配置特性模板
export async function getTemplateListByFeature(params: any) {
  return request.get<IRes<unknown>>('/design/template/checkConfig', { params })
}
